<template>
  <div class="base-badge">
    <BaseIcon v-if="icon" :name="icon" />
    <span v-else>{{ text }}</span>
  </div>
</template>

<script>
import BaseIcon from '@/components/base/BaseIcon';
export default {
  name: 'BaseBadge',
  components: {
    BaseIcon,
  },
  props: {
    icon: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
  },
  computed: {},
};
</script>

<style lang="scss">
.base-badge {
  background: $color-accent;
  border-radius: $border-radius-large;
  height: 14px;
  width: 14px;
  align-items: center;
  display: flex;
  justify-content: center;

  .base-icon {
    color: $color-white;
    height: 12px;
    width: 12px;
  }
}
</style>
